import React, { useState } from 'react';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import Icon, { IconType } from '../Icon/Icon';
import StoreFront from '../Store/StoreFront';
import OrderHistory from '../Store/OrderHistory';
import { IState, ReduxMap } from '../../redux/redux';

interface ShopPageProps extends IState {}

// Stub component for Participants tab
const ParticipantsStub = () => {
  return (
    <div className="alert alert-info">
      <h4>
        <Icon type={IconType.users} /> Participants Tab
      </h4>
      <p>This section is under development and will be implemented soon.</p>
    </div>
  );
};

const ShopPage = (props: ShopPageProps) => {
  const [activeTabIndex, setActiveTabIndex] = useState(0);

  return (
    <div className="shop-page">
      <h2>Shop</h2>
      
      <Tabs selectedIndex={activeTabIndex} onSelect={(index) => setActiveTabIndex(index)}>
        <TabList>
          <Tab>
            <Icon type={IconType.shoppingCart} /> Store
          </Tab>
          <Tab>
            <Icon type={IconType.users} /> Participants
          </Tab>
          <Tab>
            <Icon type={IconType.fileInvoice} /> Order History
          </Tab>
        </TabList>

        <TabPanel>
          <StoreFront />
        </TabPanel>

        <TabPanel>
          <ParticipantsStub />
        </TabPanel>

        <TabPanel>
          <OrderHistory showWhenEmpty={true} />
        </TabPanel>
      </Tabs>
    </div>
  );
};

export default ReduxMap(ShopPage);